import { environmentBase } from './environment-base';

export const environment = {
  ...environmentBase,
  production: false,
  site: 'astrazeneca',
  line: {
    clientId: '1655725407', // [Stage] Aiii內部開發測試
    liffId: '1655725407-oAD5NppJ', //  AZ order system
  },
  aws: {
    api: 'https://as-5582a2ede86142bb8b267258ba1a48ab.ecs.ap-northeast-1.on.aws',
  },
  cloudRun: {
    api: 'https://stage-in-api.aiii.ai/api-v2',
  },
  hcpFloatingActions: {
    requestSampleUrl: 'https://stage-s.aiii.ai/g/519c8f',
    contactSalesUrl: 'https://stage-s.aiii.ai/g/a8ebf0',
  },
  firebase: {
    apiKey: 'AIzaSyBn_5vGmSQjpMUx2CAWOVUT2n5kye2b-Vk',
    authDomain: 'astrazeneca-hcp-stage.firebaseapp.com',
    projectId: 'astrazeneca-hcp-stage',
    storageBucket: 'astrazeneca-hcp-stage.appspot.app',
    messagingSenderId: '934059698633',
    appId: '1:934059698633:web:1d2fd90c2c3ea41d632018',
    measurementId: 'G-N2ZDXXRF9P',
  },
};
